import { createEntityHooks } from '../core/createEntityHooks'
import type { BaseDocument } from '../core/types'

export interface LabelGroupDocument extends BaseDocument {
  name: string
  description: string | null
  projectId: string | null
  sortOrder: string | null
}

const hooks = createEntityHooks<LabelGroupDocument>('labelgroups')

export const useLabelGroups = (filter?: Partial<LabelGroupDocument>) => {
  const { data, isLoading, db } = hooks.useEntities(filter)
  return { labelGroups: data, isLoading, db }
}

export const useLabelGroup = (id: string | undefined) => {
  const { data, isLoading } = hooks.useEntity(id)
  return { labelGroup: data, isLoading }
}

export const useLabelGroupMutations = () => {
  const { create, update, delete: deleteEntity } = hooks.useMutations()
  return {
    createLabelGroup: create,
    updateLabelGroup: update,
    deleteLabelGroup: deleteEntity,
  }
}
